<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import DevDocsAPI from 'dashboard/api/devDocs';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const doc = ref(null);
const isFetching = ref(false);

const fetchDoc = async slug => {
  isFetching.value = true;
  doc.value = null;
  try {
    const response = await DevDocsAPI.show(slug);
    doc.value = response.data;
  } catch (error) {
    useAlert(t('DEV_DOCS.API.ERROR_MESSAGE'));
    router.push({ name: 'dev_docs_list' });
  } finally {
    isFetching.value = false;
  }
};

onMounted(() => fetchDoc(route.params.slug));
watch(
  () => route.params.slug,
  slug => fetchDoc(slug)
);
</script>

<template>
  <div class="flex-1 overflow-auto">
    <BaseSettingsHeader
      :title="doc?.title || ''"
      description=""
      :back-button-label="t('DEV_DOCS.BACK')"
    />

    <woot-loading-state v-if="isFetching" :message="t('DEV_DOCS.LOADING')" />
    <div
      v-else-if="doc"
      v-dompurify-html="doc.html"
      class="prose dark:prose-invert max-w-3xl mt-6 text-n-slate-12"
    />
  </div>
</template>
